import type { ExportConfig } from '@cobliteam/blueprint-react-renderer';
import { create } from 'zustand';

interface ExportRequestState {
  pending: ExportConfig | null;
  open: (config: ExportConfig) => void;
  close: () => void;
}

const useExportRequestStore = create<ExportRequestState>((set) => ({
  pending: null,
  open: (config) => set({ pending: config }),
  close: () => set({ pending: null }),
}));

export default useExportRequestStore;
